import { Component, OnInit,Input } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { Form } from '../../models/form';
import { FormService } from '../../services/form.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { MessageBoxCheckDialog } from '../message-box-check/message-box-check.component';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.css']
})
export class FormComponent implements OnInit {
  publicating: boolean = false;
  @Input() FormID;
  @Input() nameComponent;
  @Input() Forms;
  createForm: boolean = true;
  form: Form;
  forms:any;
  errorMessage: string;
  listQuestions:any = [];
  textQuestion: string = "";
  nameLink: string = "";
  urlLink: string = "";
  typeQuestion: number;
  descriptionQuestion: string;
  name_form: string;

  constructor(public dialogRef: MdDialogRef<FormComponent>, private dialog: MdDialog, private formService: FormService) { }

  ngOnInit() {
    if (this.nameComponent === "Crear"){
      this.createForm = true;
    } else {
      this.createForm = false;
    }

    this.form = new Form();
    if (this.FormID != '') {
      this.forms = this.Forms;
      if(this.forms.length > 0){
        //Load data form for ID
        this.forms = this.Forms;
        this.getForm(this.FormID);
      } else {
        this.forms = [new Form()];
      }
    }
    this.typeQuestion = 1;
  }

  getForm(id){
    for(let i = 0; i < this.forms.length; i++){
      if(id === this.forms[i].id){
        this.form = this.forms[i];
        this.name_form = this.form.name;
        this.form.items.forEach(element => {
          if (element.type !== 3) {
            this.nameLink = element.name;
            this.urlLink = element.url;
          } else {
            this.listQuestions.push(element);
          }
        });
      }
    }
  }

  onFormCheck(){
    if (this.createForm) {
      this.onPostForm();
    } else {
      this.onPutForm();
    }
  }

  onForm(){
    let dialogRef = this.dialog.open(MessageBoxCheckDialog);
    dialogRef.componentInstance.checkingData = true;
    dialogRef.componentInstance.message = "Los formularios no se pueden editar, revisa antes de continuar.";
    dialogRef.afterClosed().subscribe(result => {
      if (result == true){
        this.onFormCheck();
      }
    });
  }

  onPutForm() {
    this.publicating = true;
    let id = this.form.id;
    this.form = new Form();
    this.form.id = id;
    this.form.name = this.name_form;

    this.formService.putForm(this.form)
      .subscribe(
        data => {
          this.forms = data;
          this.publicating = false;
          this.dialogRef.close(data);
        },
        error => {
          console.log(error);
          this.errorMessage = <any>error;
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: error.json().name, alert:true, showIcon:true}});
        }
      );
  }

  onPostForm() {
    this.addQuestion();
    this.addLink();

    this.form.name = this.name_form;
    this.form.status = 1;
    this.form.items = this.listQuestions;
    this.publicating = true;
    this.formService.postForm(this.form)
      .subscribe(
        data => {
          this.forms = data
          this.publicating = false;
          this.dialogRef.close(data);
        },
        error => {
          console.log(error);
          this.errorMessage = <any>error
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: error.message, alert:true, showIcon:true}});
        }
      );
  }

  getTypeName(id) {
    if (id == "1") {
      return "Selección Simple (S/N)";
    } else if (id == "2") {
      return "Texto (Máx 140 caractéres)";
    } else if (id == "3") {
      return "Selección Simple (A,B,C,D)";
    } else if (id == "4") {
      return "Selección Multiple (A,B,C,D)";
    } else {
      return "Desconocido";
    }
  }

  addQuestion() {
    if (!this.textQuestion || !this.typeQuestion) {
      return;
    }

    if (!this.descriptionQuestion) {
      this.descriptionQuestion = '';
    }

    this.listQuestions.push({
      name: this.textQuestion,
      type: this.typeQuestion,
      description: this.descriptionQuestion,
    });

    this.textQuestion = "";
    this.typeQuestion = 1;
    this.descriptionQuestion = '';
  }

  addLink() {
    if (!this.nameLink || !this.urlLink) {
      return;
    }

    this.listQuestions.push({
      name: this.nameLink,
      type: 3,
      url: this.urlLink,
      description: '',
    });
  }

  removeQuestion(elm) {
    let index = -1;

    for (let _i = 0; _i < this.listQuestions.length; _i++) {
      if (this.listQuestions[_i].name == elm) {
        index = _i;
        break;
      }
    }

    if (index > -1) {
      this.listQuestions.splice(index, 1);
    }
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/form/form.component.ts